import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Form, Button, Radio } from 'semantic-ui-react';
import moment from 'moment';
import DatePicker from 'components/Forms/UI/DatePicker';
import { Column } from 'components/Layout';
import AgenziaKironService from 'shared/services/api/agenziakiron';
import { AddableSelect } from '../../UI/AddableSelect';
import DividerForm from '../../UI/DividerForm';
import { mapAgenziakironToinitialValues } from './initialValues';

export class CoordinatoreForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      agenziekiron: [],
    };
  }

  componentDidMount() {
    AgenziaKironService.getAllAgenzie(true).then((res) => {
      this.setState({
        agenziekiron: mapAgenziakironToinitialValues(res),
      });
    });
  }

  onChangeAttivo = (_event, data) => {
    const today = moment();

    if (data.checked === true) {
      this.props.setFieldValue('attivo', '1');
      this.props.setFieldValue('dataInizio', today);
    } else if (data.checked === false) {
      this.props.setFieldValue('attivo', '0');
      this.props.setFieldValue('dataFine', today);
    }
  };

  render() {
    return (
      <Form autoComplete="off" onSubmit={this.props.handleSubmit} loading={this.props.isSubmitting}>
        <Grid>
          <Column width={16} style={{ marginTop: 22 }}>
            <Radio
              label="Attivo"
              name="attivo"
              checked={this.props.values.attivo === '1'}
              toggle
              onChange={(event, data) => this.onChangeAttivo(event, data)}
              style={{ marginLeft: 5 }}
            />
          </Column>
          <Column width={8} key="dataInizio">
            <DatePicker
              {...this.props}
              value={this.props.values.dataInizio}
              onChange={this.props.setFieldValue}
              name="dataInizio"
              label="Data inizio"
            />
          </Column>

          <Column width={8} key="dataFine">
            <DatePicker
              {...this.props}
              value={this.props.values.dataFine}
              onChange={this.props.setFieldValue}
              name="dataFine"
              label="Data fine"
            />
          </Column>
          <Column width={16}>
            <AddableSelect
              {...this.props}
              required
              options={this.state.agenziekiron}
              elements={this.props.values.agenziekiron}
              type="agenziekiron"
              label="agenzie associate"
              onChange={this.props.setFieldValue}
            />
          </Column>
          <DividerForm />
          <Column width={8}>
            <Button
              onClick={this.props.closeModal}
              type="button"
              icon="delete"
              labelPosition="right"
              content="Chiudi"
            />
          </Column>
          <Column width={8} textAlign="right">
            <Button
              loading={this.props.isSubmitting}
              type="submit"
              icon="save"
              labelPosition="left"
              positive
              disabled={this.props.isSubmitting}
              content="Salva"
            />
          </Column>
        </Grid>
      </Form>
    );
  }
}

CoordinatoreForm.propTypes = {
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  closeModal: PropTypes.func,
};

export default CoordinatoreForm;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/Coordinatore/Form.js